module.exports = __webpack_public_path__ + "static/media/two.cdf12bc6.jpg";